module.exports = __webpack_public_path__ + "anylogo.png?cb900e4c0eca31f2128d319f37b82ccd";